import React from 'react';
import { NamePath } from 'antd/lib/form/interface';
import { I18n } from '@aws-amplify/core';
import { Col, Form } from 'antd';

import { EvaluatorSelect } from '@/components/ui/Inputs/EvaluatorSelect';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useEvaluators } from '@/hooks/v1';
import { CustomFormItem } from './styles';

const { useFormInstance, useWatch } = Form;

interface EvaluatorsProps {
	fieldName: NamePath;
}

export const Evaluators: React.FC<EvaluatorsProps> = ({ fieldName }) => {
	const form = useFormInstance();
	const { setFieldValue } = useFormInstance();
	const { company, organization } = useApplicationContext();

	const evaluatorId = useWatch(fieldName, form);

	const {
		data: evaluators,
		isLoading,
		isFetching,
		isError
	} = useEvaluators({
		organization_id: organization?.id,
		company_id: company?.id
	});

	function handleEvaluatorSelect(id: string) {
		setFieldValue(fieldName, id);
	}

	function handleClearEvaluators() {
		setFieldValue(fieldName, undefined);
	}

	return (
		<Col xs={24} sm={12} lg={24}>
			<CustomFormItem name={fieldName} label={I18n.get('Evaluator')} labelCol={{ span: 24 }}>
				<EvaluatorSelect
					loading={isFetching}
					allowCreation={true}
					fieldName={fieldName}
					evaluators={evaluators}
					evaluatorId={evaluatorId}
					disabled={isLoading || isFetching || isError}
					handleSelectEvaluator={handleEvaluatorSelect}
					handleClearEvaluators={handleClearEvaluators}
				/>
			</CustomFormItem>
		</Col>
	);
};
